// extracted by mini-css-extract-plugin
export default {"form":"Checkout_form__zYqGI","control":"Checkout_control__iQsYD","actions":"Checkout_actions__kHx7d","submit":"Checkout_submit__53uxn","invalid":"Checkout_invalid__eQvki"};